import { useState } from 'react'
import { useStore } from '../store'

/**
 * The only thing rendered before a session exists. No dashboard, no tiles, no cached
 * numbers — the app has nothing to show until a code has been exchanged for a session,
 * and the data endpoints refuse to answer without one.
 */
export function LoginScreen() {
  const { login } = useStore()
  const [code, setCode] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    if (!code.trim() || busy) return
    setBusy(true)
    setError(null)
    const ok = await login(code.trim())
    setBusy(false)
    if (!ok) {
      setError('That code is not recognised')
      setCode('')
    }
  }

  return (
    <div className="login">
      <form className="login-card" onSubmit={submit}>
        <div className="login-mark" aria-hidden>
          <span />
          <span />
          <span />
        </div>
        <h1>Dashboard</h1>
        <p className="muted">Enter your access code to continue.</p>

        <input
          className={error ? 'error' : ''}
          type="text"
          inputMode="text"
          autoComplete="off"
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          placeholder="XXXX-XXXX-XXXX"
          value={code}
          autoFocus
          onChange={(e) => {
            // Codes are stored uppercase and hyphen-grouped; accept whatever the keyboard
            // produces and normalise, so a phone's autocapitalise cannot lock you out.
            setCode(e.target.value.toUpperCase())
            setError(null)
          }}
        />

        {error ? <div className="login-error">{error}</div> : null}

        <button type="submit" className="btn block" disabled={!code.trim() || busy}>
          {busy ? 'Checking…' : 'Continue'}
        </button>
      </form>
    </div>
  )
}
